import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let treatment_id = useDataValue({
    context: 'image_serie_form',
    path: 'treatment_id',
    viewPath: props.viewPath,
  })
  return {
    variables: { treatment_id },
    pause: !treatment_id,
  }
}
